var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#C5C6C9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15896_5178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23742 7.00022L13.7439 1.49438C14.0857 1.15257 14.0857 0.598385 13.7439 0.256602C13.4021 -0.0852084 12.8479 -0.0852084 12.5061 0.256602L7.00022 5.76302L1.49438 0.256602C1.15257 -0.0852084 0.598385 -0.0852084 0.256602 0.256602C-0.0851811 0.598412 -0.0852084 1.15259 0.256602 1.49438L5.76302 7.00022L0.256602 12.5061C-0.0852084 12.8479 -0.0852084 13.4021 0.256602 13.7439C0.598412 14.0857 1.15259 14.0857 1.49438 13.7439L7.00022 8.23742L12.5061 13.7439C12.8479 14.0857 13.4021 14.0857 13.7438 13.7439C14.0857 13.4021 14.0857 12.8479 13.7438 12.5061L8.23742 7.00022Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15896_5178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcX);
export default __webpack_public_path__ + "static/media/ic_x.625f7f3e69ea9f1a2bc29a47a447e4ea.svg";
export { ForwardRef as ReactComponent };